import { useAppTexts } from '../../hooks/useAppTexts';

const countryToDPDParams: Partial<
  Record<
    string,
    {
      lang: string;
      addressPrefix: string;
    }
  >
> = {
  NL: {
    lang: 'nl_NL',
    addressPrefix: 'Netherlands',
  },
  BE: {
    lang: 'nl_BE',
    addressPrefix: 'Belgium',
  },
  FR: {
    lang: 'fr_FR',
    addressPrefix: 'France',
  },
  HU: {
    lang: 'hu_HU',
    addressPrefix: 'Hungary',
  },
  LU: {
    lang: 'en',
    addressPrefix: 'Luxembourg',
  },
  SI: {
    lang: 'si_SI',
    addressPrefix: 'Slovenia',
  },
  EE: {
    lang: 'et_EE',
    addressPrefix: 'Estonia',
  },
  LV: {
    lang: 'lv_LV',
    addressPrefix: 'Latvia',
  },
  LT: {
    lang: 'lt_LT',
    addressPrefix: 'Lithuania',
  },
  PT: {
    lang: 'pt_PT',
    addressPrefix: 'Portugal',
  },
  SK: {
    lang: 'sk_SK',
    addressPrefix: 'Slovakia',
  },
  CZ: {
    lang: 'cs_CZ',
    addressPrefix: 'Czech Republic',
  },
  HR: {
    lang: 'hr_HR',
    addressPrefix: 'Croatia',
  },
};

const generateShopFinderUrl = ({ postalCode, countryCode }: DPDDropoffInfoProps) => {
  const countryStrandardParams = countryToDPDParams[countryCode];

  if (countryStrandardParams) {
    const lang = countryStrandardParams.lang;
    const addressPrefix = countryStrandardParams.addressPrefix;

    return `https://www.dpdgroup.com/${countryCode.toLowerCase()}/mydpd/parcel-shops/search?lang=${lang}&address=${addressPrefix}+${postalCode}`;
  }

  // 1-off cases
  switch (countryCode) {
    case 'DE':
      return `https://my.dpd.de/shopfinder.aspx?src=${postalCode}`;
    case 'AT':
      return `https://www.mydpd.at/shopfinder?addr=${postalCode}`;
    case 'BG':
      return `https://services.speedy.bg/officesmap_v2/?src=sws&lang=offices`; // No input possible for postal code
    case 'DK':
      return `https://www.postnord.dk/en/tools/find-us/#0.18/0.9/0.1`; // No input possible for postal code
    case 'SE':
      return 'https://www.postnord.se/en/our-tools/search-letter-box-or-service-point/#3.45/63.94/15.25'; // No input possible for postal code
    default:
      return null;
  }
};

interface DPDDropoffInfoProps {
  postalCode: string;
  countryCode: string;
}

export const DPDDropoffLink = (props: DPDDropoffInfoProps) => {
  const appTexts = useAppTexts();

  const shopFinderUrl = generateShopFinderUrl(props);

  if (!shopFinderUrl) {
    return null;
  }

  return (
    <a
      className="button is-primary custom-button has-icon"
      href={shopFinderUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>{appTexts.summary.viewDropoffPoints}</span>
    </a>
  );
};
